import i18n, { InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { DEFAULT_NS, resources as i18nResources } from "./resources";
import { merge } from "lodash";

let i18nConfig: InitOptions = {
  ns: DEFAULT_NS,
  defaultNS: DEFAULT_NS,
  // the translations
  // (tip move them in a JSON file and import them,
  // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
  resources: i18nResources,
  fallbackLng: "en",
  nonExplicitSupportedLngs: true,
  // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  interpolation: {
    escapeValue: false,
  },
};

export function setupI18n(params: InitOptions) {
  i18nConfig = merge({}, i18nConfig, params);
  i18n.use(initReactI18next).use(LanguageDetector).init(i18nConfig);
}
